// ENUMs `tipo` y `estado` del modelo Certificacion
// (API-PROAPP/src/models/CertificacionModel.ts). Mantener sincronizado.

export const TIPO_CERTIFICACION_OPTIONS = [
  { value: 'residencial', label: 'Residencial' },
  { value: 'comercial', label: 'Comercial' },
];

export const TIPO_CERTIFICACION_LABELS = TIPO_CERTIFICACION_OPTIONS.reduce(
  (acc, { value, label }) => {
    acc[value] = label;
    return acc;
  },
  {}
);

export const ESTADO_CERTIFICACION_OPTIONS = [
  { value: 'vigente', label: 'Vigente' },
  { value: 'vencida', label: 'Vencida' },
  { value: 'observada', label: 'Observada' },
  { value: 'en_proceso', label: 'En proceso' },
];

export const ESTADO_CERTIFICACION_LABELS = ESTADO_CERTIFICACION_OPTIONS.reduce(
  (acc, { value, label }) => {
    acc[value] = label;
    return acc;
  },
  {}
);

export const ESTADO_CERTIFICACION_COLORS = {
  vigente: 'green',
  vencida: 'red',
  observada: 'orange',
  en_proceso: 'blue',
};
